interface ErrorMessageProps {
  message: string
  onRetry?: () => void
}

export default function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  return (
    <div
      className="card"
      style={{
        borderColor: '#313131',
        marginBottom: 24,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <svg
          width={16}
          height={16}
          style={{
            color: '#313131',
            marginTop: 4,
            flexShrink: 0,
          }}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          strokeWidth={1}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        <div style={{ flex: 1 }}>
          <p
            style={{
              fontSize: 15,
              letterSpacing: '0.15em',
              lineHeight: 1.8,
              color: '#313131',
            }}
          >
            {message}
          </p>
          {onRetry && (
            <button onClick={onRetry} className="btn-ghost" style={{ marginTop: 12 }}>
              重试
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
